// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentTypes } from '@shared/enums/environment-types.enum';

export const environment = {
  base_url: 'https://madarv2-stage.madar.app/',
  cloudFlareUrl: 'https://api-stg.madloxbserapi.org/',
  socket_url: 'https://mobiletracking-test.madar.app/',
  api_version: 'v0.0.1',
  api_v2: 'v0.0.2',
  api_prefix: '/api/',
  environmentType: EnvironmentTypes.Stage,
  appApiKey: '9NX7SXeBXfUcek25v2385BiuresPYCUdnS4DwZ8dSUg8AKRNUg8WLVj2Ve86Yry7',
  google_map_key: 'AIzaSyD4cT14FheqMnb4RdZMou4z7SaCZVEv_1k',
  google_analytics: null,
  production: false,
  launchDarklyClient: '68b3ffbce5f23509a92f784e',
  zenDeskKey: null,
  paytabsKey: 'C6KMNN-KDHV6T-VQN6G7-PQGKTG',
  encryptPasswordKey: 'nwtPzEg:Ev:E_9U#$-AE">=.UVhdkLd`',
  shipmentLogsUrl: 'https://web-avl-test.madar.app/shipments/shipment-logs',
  exportServiceUrl: 'https://bulk-export.madar.app/v0.0.1/api',
  exportShipmentUrl: 'https://bulk-upload-stage.madar.app',
  exportServiceKey: 'hEFN?qd<@CkGv4pt7_8|6/8qxp8bc',
  recaptchaV3SiteKey: '6LeytIwrAAAAAHXNKjHCNRx6WoApaULPDUL1OoP2',
  recaptchaV2SiteKey: '6LfDx08tAAAAAHBfzzOjdrmnKSZEJWVK2T8gy7ni',
  firebase: {
    apiKey: 'AIzaSyD_IK3d2Dl_7zUwkbWRSGMvtqkUjWVAe7M',
    authDomain: 'madar-c30cd.firebaseapp.com',
    projectId: 'madar-c30cd',
    storageBucket: 'madar-c30cd.appspot.com',
    messagingSenderId: '921570407460',
    appId: '1:921570407460:web:c96d5791bdcd88658314b1',
    measurementId: 'G-M2V33ZS6E6',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
